import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import QuickStartActionCardIcon from './QuickStartActionCardIcon';
import QuickStartActionSection from './QuickStartActionSection';
import styles from './QuickStartActionCard.module.scss';

export default function QuickStartActionCard({
  className,
  completed,
  isLoading,
  section,
  onQuickStartActionClick,
  testIdPrefix,
}) {
  const { descriptionId, icon, sectionId, titleId } = section;

  return (
    <div
      className={classnames(styles.card, className)}
      data-testid={`${testIdPrefix}__actionCard--${sectionId}`}
    >
      <div className={styles.left}>
        <div className={styles.headingWrapper}>
          <QuickStartActionCardIcon sectionIcon={icon} />
          <h2 className={styles.title}>
            <FormattedMessage id={titleId} />
          </h2>
        </div>

        <p className={styles.copy}>
          <FormattedMessage id={descriptionId} />
        </p>
      </div>
      <div className={styles.right}>
        <QuickStartActionSection
          completed={completed}
          isLoading={isLoading}
          section={section}
          onQuickStartActionClick={onQuickStartActionClick}
          testIdPrefix={testIdPrefix}
        />
      </div>
    </div>
  );
}

QuickStartActionCard.propTypes = {
  className: PropTypes.string,
  completed: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  section: PropTypes.shape().isRequired,
  onQuickStartActionClick: PropTypes.func.isRequired,
  testIdPrefix: PropTypes.string.isRequired,
};

QuickStartActionCard.displayName = 'QuickStartActionCard';
